import { useState } from 'react';
import { supabase } from '../utils/supabaseClient';
import api from '../utils/api';
import { useOrg } from '../contexts/OrgContext';

export default function EstimateUploader({ onUploaded }) {
  const [file, setFile] = useState(null);
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const { permissions } = useOrg();

  const input =
    'w-full rounded-xl bg-zinc-900/60 border border-white/10 px-4 py-2.5 text-zinc-100 placeholder:text-zinc-400 focus:outline-none focus:ring-2 focus:ring-amber-400/70';
  const btn =
    'rounded-xl px-4 py-2 text-sm font-semibold text-zinc-900 bg-gradient-to-b from-amber-300 to-amber-500 shadow-[0_1px_0_0_rgba(255,255,255,0.35)_inset,0_10px_24px_-10px_rgba(245,158,11,0.85)] disabled:opacity-60';

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    if (!permissions.canUpload) {
      setErr('Uploads are disabled for your role.');
      return;
    }
    if (!file) return setErr('Choose a file');
    setBusy(true);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) throw new Error('Sign in');

      // object path: <userId>/estimates/<uuid>-<filename>
      const userId = session.user.id;
      const safeName = file.name.replace(/\s+/g, '_');
      const objectPath = `${userId}/estimates/${crypto.randomUUID()}-${safeName}`;

      // 1) register metadata (RLS ensures owner_user === auth.uid)
      const reg = await api.post('/estimates/register', { name: name || file.name, objectPath });
      const { bucket } = reg.data;

      // 2) upload the actual file (Storage RLS reads estimate_files)
      const { error } = await supabase.storage.from(bucket).upload(objectPath, file, { upsert: false });
      if (error) throw error;

      setFile(null); setName('');
      onUploaded?.();
    } catch (e2) {
      console.error(e2);
      setErr(e2.message || 'Upload failed');
    } finally {
      setBusy(false);
    }
  };

  if (!permissions.canUpload) {
    return (
      <div className="text-sm text-zinc-500">
        Uploads are disabled for your current plan or role.
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} className="space-y-3">
      <input className={input} placeholder="Display name (optional)" value={name} onChange={e=>setName(e.target.value)} />
      <input className={input} type="file" onChange={e=>setFile(e.target.files?.[0] || null)} />
      <button className={btn} disabled={busy}>{busy ? 'Uploading...' : 'Upload estimate'}</button>
      {err && <div className="text-red-400 text-sm">{err}</div>}
    </form>
  );
}



